import { AxiosClient } from "./AxiosClient";

export const createTicket = (ticket_data, media) => {
  try {
    return AxiosClient.post("tickets/createTicket", { ticket_data, media });
  } catch (e) {
    console.log(e);
  }
};

export const addNewTicketData = (
  ticket_id,
  ticket_data,
  media,
  ticket_status,
) => {
  try {
    return AxiosClient.post("tickets/addNewTicketData", {
      ticket_id,
      ticket_data,
      media,
      ticket_status,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getAllUsersTickets = () => {
  try {
    return AxiosClient.post("tickets/getAllUsersTickets", {});
  } catch (e) {
    console.log(e);
  }
};

export const deleteTicket = (ticket_id) => {
  try {
    return AxiosClient.post("tickets/deleteTicket", { ticket_id });
  } catch (e) {
    console.log(e);
  }
};

export const fileUpload = (file) => {
  try {
    return AxiosClient.post("chat/fileUpload", file);
  } catch (e) {
    console.log(e);
  }
};

export const getTickets = () => {
  try {
    return AxiosClient.post("tickets/getTickets", {});
  } catch (e) {
    console.log(e);
  }
};

export const getTicketThread = (ticket_id) => {
  try {
    return AxiosClient.post("tickets/getTicketThread", { ticket_id });
  } catch (e) {
    console.log(e);
  }
};
